import type {
  SearcherRegistration,
  SearchResult,
  SearcherConfig,
} from "@pineseed/gui/types";

/**
 * Web Searcher
 * STRICT RULE: Contains ONLY business logic - no UI imports, no direct atom mutations
 * Implements search functionality for web results
 */

export class WebSearcher {
  private static instance: WebSearcher;
  private config: SearcherConfig = {
    type: "web",
    title: "Web",
    icon: "globe",
    description: "Search the web",
    enabled: true,
  };

  public static getInstance(): WebSearcher {
    if (!WebSearcher.instance) {
      WebSearcher.instance = new WebSearcher();
    }
    return WebSearcher.instance;
  }

  /**
   * Get searcher registration for the search manager
   */
  public getRegistration(): SearcherRegistration {
    return {
      config: this.config,
      search: this.search.bind(this),
    };
  }

  /**
   * Search web results
   */
  public async search(query: string): Promise<SearchResult[]> {
    if (!query.trim()) {
      return [];
    }

    // TODO: Implement actual web search API integration
    return [];
  }

  /**
   * Enable/disable this searcher
   */
  public setEnabled(enabled: boolean): void {
    this.config.enabled = enabled;
  }

  /**
   * Get searcher configuration
   */
  public getConfig(): SearcherConfig {
    return { ...this.config };
  }
}

// Singleton instance
export const webSearcher = WebSearcher.getInstance();
